module.exports = __webpack_public_path__ + "static/consult3-ce738ce5eb94357c589ec8263655ea28.jpg";